export default [
  {
    path: '/signatures',
    name: 'signature',
    meta: { requiresAuth: true },
    component: () => import('@/pages/signature/index.vue')
  }
]
